import { CurrencyPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { ITransactionSummary } from '../../../transactions/transaction.model';
import { GridViewType } from '../../../../shared/components/grid/grid-config';
import { CapitalizePipe } from '../../../../shared/pipes/capitalize.pipe';
import { CcMaskPipe } from '../../../../shared/pipes/cc-mask.pipe';
import { transactionActions } from 'app/features/transactions/pages/history/history-view-config/actions';

export const CustomerTransactionsConfig: GridViewType<ITransactionSummary> = {
  filter: (trans: ITransactionSummary) => {
    return ['SALE', 'CAPTURE', 'REFUND', 'VOID'].includes(<string>trans.transactionType);
  },
  showTotals: true,
  columns: [
    {
      code: 'actions',
      isActionColumn: true,
      actions: transactionActions,
    },
    {
      code: 'timestamp',
      label: 'Date/Time',
      pipes: [{ pipe: DatePipe, args: 'short' }],
      class: 'column-120',
    },
    {
      label: 'Type',
      code: 'transactionType',
      filterType: 'select',
      pipes: [{ pipe: CapitalizePipe, args: 'short' }],
      template: 'tranTypeTemplate',
      class: 'column-150',
    },
    {
      label: 'ACH Payment',
      code: 'isACHTransaction',
      filterType: 'select',
      visible: false,
    },
    {
      label: 'Card Payment',
      code: 'isCardPayment',
      filterType: 'select',
      visible: false,
      getValue: (trans: ITransactionSummary) => {
        return trans.isACHTransaction === false;
      },
    },
    {
      label: 'Debit Card',
      code: 'isDebitCardTransaction',
      filterType: 'select',
      visible: false,
    },
    {
      label: 'Credit Card',
      code: 'isCreditCardTransaction',
      filterType: 'select',
      visible: false,
    },
    {
      label: 'Batch',
      code: 'batch',
      class: 'column-80',
      visible: false,
    },
    {
      label: 'Trans.ID',
      code: 'transactionId',
      visible: true,
      template: 'transIdTemplate',
    },
    {
      label: 'Voided',
      code: 'statusVoided',
      template: 'voidTemplate',
      class: 'column-90',
      filterType: 'select',
      visible: false,
    },

    {
      code: 'batchItem',
      label: 'Item',
      class: 'column-small',
      visible: false,
    },
    {
      label: 'Card',
      code: 'cardType',
      filterType: 'select',
      class: 'column-small',
      pipes: [{ pipe: UpperCasePipe }],
    },
    {
      label: 'Card Number',
      code: 'account',
      pipes: [{ pipe: CcMaskPipe, args: { prefix: '****-' } }],
      filterType: 'select',
    },
    {
      label: 'Reference Number',
      code: 'processorCustRef',
      filterType: 'select',
    },
    {
      label: 'Channel',
      code: 'freelyContextChannel',
      filterType: 'select',
      visible: false,
    },
    {
      label: 'User ID',
      code: 'freelyContextUserId',
      filterType: 'select',
      visible: false,
    },
    {
      label: 'Cardholder',
      code: 'CustomerCardholder',
      template: 'custCombinedTemplate',
      class: 'column-wide',
      filterType: 'select',
      visible: false,
      getValue: (trans: ITransactionSummary) => {
        if (trans.customerReferenceNumber || trans.customerName || trans.cardholderName) {
          const line1 = `${trans.customerName || ''}-${trans.customerReferenceNumber || ''}`;
          return `${line1} / ${trans.cardholderName || ''}`;
        }
        return '';
      },
    },
    {
      label: 'Invoice Total',
      code: 'invoiceTotal',
      getValue: (trans: ITransactionSummary) => {
        return trans.amount - (trans.amountDetails?.supplementalFee || 0);
      },
      pipes: [{ pipe: CurrencyPipe }],
      showTotal: true,
      visible: true,
    },
    {
      label: 'Capital Charge',
      code: 'amountDetails.supplementalFee',
      pipes: [{ pipe: CurrencyPipe }],
      showTotal: true,
      visible: true,
    },
    {
      label: 'Payment',
      code: 'amount',
      pipes: [{ pipe: CurrencyPipe }],
      showTotal: true,
    },
  ],
};
